/**
 * 列操作方法
 */
import { ITableColumn } from '../model';

export function getColumnAttrs<T>(
  dataItem: T,
  column: ITableColumn<T>,
  columnIndex: number,
  rowIndex: number
) {
  if (column.onCell) {
    return column.onCell(dataItem, rowIndex, columnIndex, column);
  }
  return {};
}

export function getHeaderColumnAttrs<T>(
  column: ITableColumn<T>,
  columnIndex: number
) {
  if (column.onHeaderCell) {
    return column.onHeaderCell(column, columnIndex);
  }
  return {};
}

export const getColumnWidth = (width?: string | number) => {
  if (width === undefined) {
    return {};
  }
  const style: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
  };
  return style;
};
